// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2868 ? "app-layout" : chunkId) + "." + {"735":"908de0d9","1176":"2e2ae94c","1917":"4c5dc704","2868":"beac5a58","3353":"2e2ae94c","7045":"678a7851"}[chunkId] + ".chunk.css";
};